import { useState, useEffect, useRef } from "react"
import { debounce } from "lodash"
import { SearchIconStroke } from "../../../../assets/icons/common/common-icons"
import {
    ClearButton,
    SearchIcon,
    SearchInput,
    VaultSearchBarWrapper,
    VaultSearchComponentWrapper,
    VaultSearchTitle
} from "./VaultSearch.styles"
import { useStore } from "../../../app/data/root.store"
import { observer } from "mobx-react"

export const VaultSearch = observer(({ isMobile = false, hideTitleOnMobile = false }) => {
    const { vaultStore, uiStore } = useStore();
    const [inputValue, setInputValue] = useState(vaultStore.searchValue || "");

    const isOnMobile = isMobile || !uiStore.isDesktopView;

    const debouncedSetSearchValue = useRef(
        debounce((value) => {
            vaultStore.setSearchValue(value);
        }, 300)
    );

    useEffect(() => {
        setInputValue(vaultStore.searchValue || "");
    }, [vaultStore.searchValue]);

    useEffect(() => {
        const debounced = debouncedSetSearchValue.current;
        return () => debounced.cancel();
    }, []);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        debouncedSetSearchValue.current(value);
    };

    const handleClear = () => {
        setInputValue("");
        vaultStore.clearSearchValue();
    };

    const isSearchDisabled = !vaultStore.meta?.totalVaultsInDB;

    return (
        <VaultSearchComponentWrapper isAssetVaultTab={vaultStore.isAssetVaultTab}>
            {!vaultStore.isAssetVaultTab && !(isOnMobile && hideTitleOnMobile) ? <VaultSearchTitle>Vault</VaultSearchTitle> : null}
            <VaultSearchBarWrapper
                isAssetVaultTab={vaultStore.isAssetVaultTab}
                isMobile={isOnMobile}
                isSearchDisabled={isSearchDisabled}
            >
                <SearchIcon><SearchIconStroke /></SearchIcon>
                <SearchInput
                    type="text"
                    placeholder="Search your files..."
                    value={inputValue}
                    onChange={handleInputChange}
                    disabled={isSearchDisabled}
                />
                {inputValue ? <ClearButton onClick={handleClear}>×</ClearButton> : null}
            </VaultSearchBarWrapper>
        </VaultSearchComponentWrapper>
    )
})